// src/components/layout/sidebarGroups.js (NEW FILE)
import { PERMISSIONS } from '../../utils/permissions';
import { FaTachometerAlt, FaUsers, FaTasks, FaComments, FaChartBar, FaCog, FaUserShield, FaTags } from 'react-icons/fa';

// Define the structure for sidebar groups and items
export const sidebarGroups = (t) => [ // Function allows passing 't' for initial label translation if needed
  {
    // No title for the main dashboard link - it appears first
    items: [
      { labelKey: 'dashboard', to: '/dashboard', icon: FaTachometerAlt, permission: PERMISSIONS.VIEW_DASHBOARD },
    ]
  },
  {
    titleKey: 'management', // Translation key for the group title
    items: [
      { labelKey: 'customers', to: '/customers', icon: FaUsers, permission: PERMISSIONS.VIEW_CUSTOMERS },
      { labelKey: 'tasks', to: '/tasks', icon: FaTasks, permission: PERMISSIONS.VIEW_TASKS },
      { labelKey: 'interactions', to: '/interactions', icon: FaComments, permission: PERMISSIONS.VIEW_INTERACTIONS },
    ]
  },
  {
    titleKey: 'analysis',
    items: [
      { labelKey: 'reports', to: '/reports', icon: FaChartBar, permission: PERMISSIONS.VIEW_REPORTS },
    ]
  },
  {
    titleKey: 'administration',
    items: [
      { labelKey: 'userManagement', to: '/settings/users', icon: FaCog, permission: PERMISSIONS.USER_MANAGEMENT_READ }, // Link text targets User Mgt
      { labelKey: 'roleManagement', to: '/settings/roles', icon: FaUserShield, permission: PERMISSIONS.USER_MANAGEMENT_CREATE }, // Admins likely manage roles
      { labelKey: 'lookupManagement', to: '/settings/lookups', icon: FaTags, permission: PERMISSIONS.VIEW_SETTINGS }, // General settings permission to view
    ]
  },
  // Add more groups as needed
];